import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import logo from '@/imgs/logo.png'

type Props = {
  onRetry?: () => void
}

export function OfflineScreen({ onRetry }: Props) {
  const { t } = useTranslation()
  return (
    <div dir='rtl' className='bg-background-app fixed inset-0 z-50 flex min-h-dvh w-full items-center justify-center p-6'>
      <div className='flex max-w-sm flex-col items-center gap-6 text-center'>
        <img src={logo} alt='ShipTanbul' className='h-auto w-40' />
        <div className='space-y-2'>
          <h1 className='text-text-primary text-2xl font-bold'>{t('native.offlineTitle')}</h1>
          <p className='text-text-secondary text-base'>{t('native.offlineBody')}</p>
        </div>
        {onRetry ? (
          <Button type='button' size='lg' onClick={onRetry}>
            {t('native.retry')}
          </Button>
        ) : null}
      </div>
    </div>
  )
}
